function doAccordionVideo() {
  if (!customElements.get("accordion-video")) {
    customElements.define(
      "accordion-video",
      class AccordionVideo extends HTMLElement {
        constructor() {
          super();
          this.accordionContent = this.querySelectorAll(".accordion-content");
          this.accordionVideos = this.querySelectorAll(
            ".accordion-videos li.accordion-videos-item"
          );
          if (this.accordionContent == null) {
            console.log(`this.accordionContent == null`);
            return undefined;
          }

          this.init();
        }

        init() {
          this.accordionContent.forEach((content) => {
            const accordionHeader = content.querySelector(".accordion-header");
            accordionHeader.addEventListener("click", () => {
              this.stopAllVideos();
              if (content.dataset.status == "0") {
                this.hideAllAccordionBodies(content.dataset.loopIndex);
                this.hideAllVideos(content.dataset.loopIndex);
                this.toggleAccordionBody(content, "show");
                this.toggleVideo(content.dataset.loopIndex);
                content.setAttribute("data-status", 1);
                return;
              }

              if (content.dataset.status == "1") {
                this.toggleAccordionBody(content, "hide");
                content.setAttribute("data-status", 0);
                return;
              }
            });
          });
        }

        /**
         * Hide all accordion bodies except if the loopIndex matches the current one
         * @param {string nubmer} loopIndex
         */
        hideAllAccordionBodies(loopIndex) {
          this.accordionContent.forEach((content) => {
            if (content.dataset.loopIndex != loopIndex) {
              content.setAttribute("data-status", 0);
              this.toggleAccordionBody(content, "hide");
            }
          });
        }

        /**
         * Hide all accordion videos except if the loopIndex matches the current one
         * @param {string nubmer} loopIndex
         */
        hideAllVideos(loopIndex) {
          this.accordionVideos.forEach((li) => {
            if (li.dataset.loopIndex != loopIndex) {
              li.style.display = "none";
              li.style.opacity = 0;
            }
          });
        }

        showVideo(loopIndex) {
          const videoToShow = this.querySelector(
            `.accordion-videos li[data-loop-index="${loopIndex}"]`
          );
          if (videoToShow == null) {
            console.log("videoToShow is null");
            return null;
          }

          videoToShow.style.display = "block";
          setTimeout(() => {
            videoToShow.style.opacity = 1;
          }, 200);
        }

        toggleVideo(loopIndex, action = "show") {
          const videoToShow = this.querySelector(
            `.accordion-videos li[data-loop-index="${loopIndex}"]`
          );

          if (videoToShow == null) {
            console.log("videoToShow is null");
            return null;
          }
          if (action === "show") {
            videoToShow.style.display = "block";
            setTimeout(() => {
              videoToShow.style.opacity = 1;
            }, 200);
          }

          if (action === "hide") {
            videoToShow.style.opacity = 0;
            setTimeout(() => {
              videoToShow.style.display = "none";
            }, 200);
          }
        }

        /**
         *
         * @param {element} accordionBody
         * @param {string} action [show, hide]
         */
        toggleAccordionBody(accordionContent, action = "show") {
          const accordionBody =
            accordionContent.querySelector(".accordion-body");

          const accordionBodyInner = accordionBody.querySelector(
            ".accordion-body-inner"
          );

          const iconPlus = accordionContent.querySelector(".icon-plus");
          const iconMinus = accordionContent.querySelector(".icon-minus");
          if (iconMinus == null) return null;
          if (action === "show") {
            accordionBody.style.display = "block";
            iconPlus.style.display = "none";
            iconMinus.style.display = "block";
            setTimeout(() => {
              accordionBodyInner.style.opacity = 1;
            });
          }

          if (action === "hide") {
            accordionBodyInner.style.opacity = 0;
            iconMinus.style.display = "none";
            iconPlus.style.display = "block";
            setTimeout(() => {
              accordionBody.style.display = "none";
            }, 100);
          }
        }

        stopAllVideos() {
          const allStopButtons = this.querySelectorAll(".localVideo-stop");
          if (allStopButtons == null) return null;
          if (allStopButtons.length === 0) return null;

          allStopButtons.forEach((stopButton) => {
            //assumes using <local-video> where jquery will be loaded
            $(stopButton).trigger("click");
          });
        }
      }
    );
  }
}

doAccordionVideo();
